module.exports = __webpack_public_path__ + "static/media/sink.7ce3213d.svg";